<style scoped>
  @import 'https://g.alicdn.com/de/prismplayer/2.8.0/skins/default/aliplayer-min.css';
</style>

<template>
  <div ref='myplayerfather'>
    <div className="prism-player" id="J_prismPlayer" style="" ref='myplayer'></div>
  </div>
</template>

<script>
import { getUrlCode, handleRes } from '@/js/public'
import { mapState } from 'vuex'
import { orgGetVideoPlayauth } from '@/api/getApi'

export default {
  name: 'aliplayer',
  data () {
    return {
      player: '',
      msg: `11`,
      playauth: null,
      cover: ''
    }
  },
  props: {
    source: String
  },
  computed: {
    orgCode: () => getUrlCode('orgID'),
    ...mapState({
      apliplayerID: state => state.apliplayerID
    })
  },
  mounted: async function () {
    // eslint-disable-next-line
    await this.getPlayauth()
    const _this = this
    // eslint-disable-next-line
    this.player = new Aliplayer({
      id: 'J_prismPlayer',
      width: '100%',
      autoplay: false,
      vid: this.source,
      playauth: _this.playauth,
      cover: 'http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png'
    }, function (player) {
      player.pause()
    })
  },
  components: {},
  methods: {
    pause () {
      this.player.pause()
    },
    dispose () {
      this.player.dispose()
      this.player.replay()
    },
    replay () {
      this.player.replay()
    },
    // 获取播放的Token
    async getPlayauth (vid) {
      const params = {
        video_id: vid || this.apliplayerID || this.source
      }
      const res = await orgGetVideoPlayauth(params)
      handleRes(res, '', () => {
        this.playauth = res.data.PlayAuth
        this.cover = res.data.VideoMeta.CoverURL
        if (this.player !== '') {
          this.player._options.playauth = res.data.PlayAuth
          this.player._options.vid = vid
          this.player._options.cover = res.data.VideoMeta.CoverURL
        }
      }, '获取视频播放地址失败，请稍候再试')
    }
  },
  beforeCreate () {
  },
  beforeDestroy () {
  },
  async created () {
  }
}
</script>
